import {ClassType, GroupType, StudentTabId, StudentType} from './types';
import {StudentWithUnit} from '../types';
import {useTabs, useSelections} from './hooks';
import {StudentList} from './components/student-list';
import {ClassList} from './components/class-list';
import {GroupList} from './components/group-list';
import {
	Tabs,
	ExpandablePanelContentWrapper,
} from '@esgi/main/features/teacher/home';
import {Title} from './index.styled';

type Props = {
	classes: ClassType[];
	groups: GroupType[];
	students: StudentType[];
	onChange: (value: StudentWithUnit[]) => void;
};

export function StudentsControl({classes, groups, students, onChange}: Props) {
	const {activeTab, setActiveTab, tabItems} = useTabs();
	const {selectedStudents, toggleStudent, toggleStudents} = useSelections(onChange);

	const getTabContent = (): JSX.Element => {
		if (activeTab === StudentTabId.Classes) {
			return (
				<ClassList
					classes={classes}
					students={students}
					selectedStudents={selectedStudents}
					toggleStudents={toggleStudents}
				/>
			);
		}

		if (activeTab === StudentTabId.Groups) {
			return (
				<GroupList
					classes={classes}
					groups={groups}
					students={students}
					selectedStudents={selectedStudents}
					toggleStudents={toggleStudents}
				/>
			);
		}

		if (activeTab === StudentTabId.Students) {
			return (
				<StudentList
					students={students}
					selectedStudents={selectedStudents}
					toggleStudent={toggleStudent}
				/>
			);
		}
	};

	return (
		<>
			<Title size='small'>Select Students</Title>
			<ExpandablePanelContentWrapper withTabs={Boolean(tabItems.length)}>
				<Tabs<StudentTabId>
					activeTab={activeTab}
					setActiveTab={setActiveTab}
					tabItems={tabItems}
				/>
				{getTabContent()}
			</ExpandablePanelContentWrapper>
		</>
	);
}
